import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSetScopedAtom } from '@lemon8/web-app-shared/ssr';
import { $CurrentExperienceAnswerFold } from '../../atoms';
import { useViewTracking } from '~/utils/use-view-tracking';
import { ModuleType } from '~/utils/module-type';
import { ClickPosition } from '~/utils/click-position';
import ChevronDownFill from 'icon/chevron_down_fill.svg';
import { buildInnerHtml } from '@lemon8/web-app-shared/util';
import cls from 'classnames';

import './style.scss';

interface PartialArticleBodyProps {
  shortContent: string;
}

export const PartialArticleBody: FC<PartialArticleBodyProps> = (props) => {
  const { shortContent } = props;
  const { t } = useTranslation();
  const setIsFold = useSetScopedAtom($CurrentExperienceAnswerFold);

  const partialAnswerRef = useViewTracking({
    onView: useCallback(() => {
      window.Tea('wap_cta_show', {
        current_page_module: ModuleType.experience_content,
        current_position: ClickPosition.experience_answer,
        is_cta: 0,
      });
      window.Tea('wap_cta_show', {
        current_page_module: ModuleType.experience_content,
        current_position: ClickPosition.experience_seemore,
        is_cta: 0,
      });
    }, []),
  });

  const handleClick = useCallback(() => {
    window.Tea('wap_click', {
      current_page_module: ModuleType.experience_content,
      current_position: ClickPosition.experience_seemore,
      is_cta: 0,
    });
    setIsFold(false);
  }, []);

  const renderFoldedContent = (): JSX.Element => {
    return (
      <div className={cls('article-content-read-more-banner')}>
        <div className="read-more-btn" onClick={handleClick}>
          <div className="read-btn-desc">{t('read_more')}</div>
          <div className="read-btn-arrow-right">
            <ChevronDownFill />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="experience-partial-article-body">
      <div className="experience-partial-article-folded" ref={partialAnswerRef}>
        <div
          className="experience-partial-article-folded-inner"
          dangerouslySetInnerHTML={buildInnerHtml(shortContent)}
        />
        {renderFoldedContent()}
      </div>
    </div>
  );
};
